// extracted by mini-css-extract-plugin
export default {"box":"About_box__3-UFl","container":"About_container__Qh6n0","header":"About_header__U1MsE"};